<hr-accordion>
    <form hrAccordion [formGroup]="codeTextQueryModelForm">
        <div class="p-fluid formgrid grid">
            <hvl-form-item label="{{ hrKey.hrCommonCodeText.table | translate }}" class="col-2">
                <p-dropdown uiKovanDropdown
                    #discriminator
                    id="{{ pageCodeModel.pageCode + '_discriminatorId' }}"
                    name="discriminator"
                    filter="true"
                    resetFilterOnHide="true"
                    class="form-control"
                    [options]="discriminatorValueList"
                    optionLabel="{{ 'label' | translate }}"
                    [optionValue]="'value'"
                    formControlName="discriminator"
                    [(ngModel)]="selectedDiscriminator"
                    (onChange)="onDiscriminatorValueChanged($event.value)"
                    appendTo="body"
                >
                    <ng-template let-selectedItem pTemplate="selectedItem">
                        <ng-container *ngIf="selectedItem">
                            {{ selectedItem?.label | translate }}
                        </ng-container>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                        <div class="chart-item">
                            <div>{{ item.label | translate }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </hvl-form-item>
            <hvl-form-item label="{{ hrKey.hrCommon.code | translate }}" class="col-2">
                <input id="code" type="text" formControlName="code" pInputText [disabled]="!discriminator.value" />
            </hvl-form-item>
            <hvl-form-item label="{{ hrKey.hrCommon.shortText | translate }}" class="col-2">
                <input id="shortText" type="text" formControlName="shortText" pInputText
                       [disabled]="!discriminator.value" />
            </hvl-form-item>
            <hvl-form-item label="{{ hrKey.hrCommon.longText | translate }}" class="col-2">
                <input id="longText" type="text" formControlName="longText" pInputText
                       [disabled]="!discriminator.value" />
            </hvl-form-item>
            <hvl-form-item key="orderLevel" label="{{ hrKey.hrCommonCodeText.orderLevel | translate }}" class="col-2">
                <p-inputNumber mode="decimal" min="0" [max]="99999" [maxFractionDigits]="0"
                               formControlName="orderLevel"></p-inputNumber>
            </hvl-form-item>
        </div>
        <ui-advance-search-footer-buttons [searchButtonDisabled]="changeValue == null" (onClear)="clear()" (onSearch)="onDiscriminatorValueSelect()"
                                          [idPrefix]="pageCodeModel.pageCode"></ui-advance-search-footer-buttons>
    </form>
</hr-accordion>
<div class="grid mt-2">
    <div class="{{ listDivClass }}">
        <p-card>
            <ng-template pTemplate="header">
                <ui-page-title title="{{ listTitle || hrKey.hrCommonCodeText.listTitle | translate }}"
                               pageCode="{{ pageCodeModel.list }}"></ui-page-title>
            </ng-template>
            <div class="button-div">
                <ng-content select="[toolbar]"></ng-content>
            </div>
            <div>
                <p-table
                    #dataTable
                    styleClass="p-datatable-striped"
                    [id]="pageCodeModel.list + '_list'"
                    [value]="tableList"
                    [lazy]="true"
                    (onLazyLoad)="loadCodeTextTableEvent($event)"
                    [totalRecords]="totalElements"
                    [loading]="loading"
                    selectionMode="single"
                    [(selection)]="selectedItem"
                    dataKey="id"
                    (onRowSelect)="onRowSelect()"
                    (onRowUnselect)="onRowUnSelect()"
                    [resetPageOnSort]="false"
                    [paginator]="true"
                    [rows]="10"
                    [rowsPerPageOptions]="[10, 25, 50]"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="{{'hrCommon.totalRecords' | translate}} {totalRecords} "
                >
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="discriminator">
                                {{ hrKey.hrCommonCodeText.discriminator | translate }}
                                <p-sortIcon field="discriminator"></p-sortIcon>
                            </th>
                            <th pSortableColumn="code">
                                {{ hrKey.hrCommon.code | translate }}
                                <p-sortIcon field="code"></p-sortIcon>
                            </th>
                            <th pSortableColumn="detailMap.shortText">
                                {{ hrKey.hrCommon.shortText | translate }}
                                <p-sortIcon field="detailMap.shortText"></p-sortIcon>
                            </th>
                            <th pSortableColumn="detailMap.longText">
                                {{ hrKey.hrCommon.longText | translate }}
                                <p-sortIcon field="detailMap.longText"></p-sortIcon>
                            </th>
                            <th pSortableColumn="orderLevel">
                                {{ hrKey.hrCommonCodeText.orderLevel | translate }}
                                <p-sortIcon field="orderLevel"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-codeText>
                        <tr [pSelectableRow]="codeText">
                            <td>{{ codeText.discriminator }}</td>
                            <td>{{ codeText.code }}</td>
                            <td>{{ codeText?.shortText }}</td>
                            <td>{{ codeText?.longText }}</td>
                            <td>{{ codeText.orderLevel }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="5">{{ 'noRecordsFound'| translate }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-card>
    </div>
    <ng-content select="[modelForm]"></ng-content>
</div>
